module.exports = __webpack_public_path__ + "static/media/fa-angle-down.3bf8e27f.svg";